import { popupActions } from '../../services';

let index = 0;

export const popupReducer = ( state = [], action ) => {
  switch ( action.type ) {
    case popupActions.SETPOPUP:
      action.popup.id = index++;
      return [...state, action.popup];
    case popupActions.UPDATEPOPUP:
      return state.map(p => {
        if(p.id === index - 1) p.showConfirmation = action.value;
        return p;
      });
    case popupActions.HIDEPOPUP:
      let foundPopup = state.find( a => a.id === action.id );
      if ( foundPopup && foundPopup.onClose ) {
        foundPopup.onClose();
      }
      return !action.id ? [] : state.remove( action, item => item.id === action.id );
    default:
      return state;
  }
};
